import { useAuthentication } from '@app/src/context/AuthenticationContext'
import { Solution } from '@app/src/wf-constants'

/**
 * True for the assessing ("accessor") solutions (Sourcing, Finance, Investing, Management) and false
 * for Transparency and the admin "default" context. Management has no permission constant, so this
 * gates on the solution scope rather than permissions.
 */
const useIsAccessorSolution = (): boolean => {
  const { scope } = useAuthentication()
  const solution = scope.solution

  return Boolean(solution) && solution !== Solution.TRANSPARENCY && solution !== 'default'
}

export default useIsAccessorSolution
